import { useEffect } from 'react';

import { prefetchWholeVolume } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { debug } from '@/shared/lib';

export const useWholeVolumePrefetch = ({
  isEnabled,
  volumeFileID,
}: {
  isEnabled: boolean;
  volumeFileID: string | null;
}) => {
  useEffect(() => {
    if (!isEnabled || !volumeFileID) {
      return;
    }

    const abortController = new AbortController();
    const prefetch = prefetchWholeVolume(volumeFileID, abortController.signal)
      .then((started) => {
        if (abortController.signal.aborted) {
          started?.release();

          return null;
        }

        return started;
      })
      .catch((error: unknown) => {
        debug('[FullHeadMPR] Whole volume prefetch failed', error);

        return null;
      });

    return () => {
      abortController.abort();
      prefetch.then((started) => started?.release());
    };
  }, [isEnabled, volumeFileID]);
};
